export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5890.7f8a72f5.jpg";